import { render, staticRenderFns } from "./invite-suppliers.vue?vue&type=template&id=a600c346&"
import script from "./invite-suppliers.vue?vue&type=script&lang=js&"
export * from "./invite-suppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports